import React from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArticleIcon from "@mui/icons-material/Article";
import SwipeLeftIcon from "@mui/icons-material/SwipeLeft";
import CommentIcon from "@mui/icons-material/Comment";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useHistory } from "react-router-dom";

const PmsNav = ({
  permissions,
  currentPath,
  openConferenceMenu,
  handleClickConferenceMenu,
  openConferenceEventManagemant,
  handleClickopenConferenceEventManagemant,
  openConferenceParticpant,
  handleClickConferenceParticpant,
  openConferenceSetting,
  handleClickConferenceShopSetting,
  openClickConferenceUser,
  handleClickConferenceUser,
}) => {
  const history = useHistory();

  return (
    <div>
      {currentPath !== "/admin/events" && (
        <>
          <Divider sx={{ my: 1 }} />

          <ListItemButton
            onClick={handleClickConferenceMenu}
            sx={{ color: "#1976d2" }}
          >
            <ListItemIcon sx={{ color: "#1976d2" }}>
              <DashboardIcon
                onClick={() => history.push("/admin/conference/dashbord")}
              />
            </ListItemIcon>
            <ListItemText primary="Conference MS" sx={{ color: "#1976d2" }} />
            {openConferenceMenu ? (
              <ExpandLess />
            ) : (
              <ExpandMore sx={{ color: "#1976d2" }} />
            )}
          </ListItemButton>
        </>
      )}
      <Collapse in={openConferenceMenu} timeout="auto" unmountOnExit>
        {currentPath !== "/admin/events" && (
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 1 }}
              onClick={() => history.push("/admin/conference/dashbord")}
            >
              <ListItemIcon sx={{ color: "#1976d2" }}>
                <DashboardIcon
                  onClick={() => history.push("/admin/conference/dashbord")}
                />
              </ListItemIcon>
              <ListItemText primary="Conference Dashbord" />
            </ListItemButton>
            {permissions["p_conference-collection"] === true && (
              <ListItemButton
                sx={{ pl: 1 }}
                onClick={() => history.push("/admin/conference/collection")}
              >
                <ListItemIcon sx={{ color: "#1976d2" }}>
                  <DashboardIcon
                    onClick={() => history.push("/admin/conference/collection")}
                  />
                </ListItemIcon>
                <ListItemText primary="C-Collection" />
              </ListItemButton>
            )}
            <Divider sx={{ my: 1 }} />
            <Divider sx={{ my: 1 }} />
            {permissions["p_conference-category-list"] === true && (
              <>
                <ListItemButton
                  onClick={handleClickopenConferenceEventManagemant}
                  sx={{ color: "#1976d2" }}
                >
                  <ListItemIcon sx={{ color: "#1976d2" }}>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="C-Management"
                    sx={{ color: "#1976d2" }}
                  />
                  {openConferenceEventManagemant ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore sx={{ color: "#1976d2" }} />
                  )}
                </ListItemButton>
                <Divider sx={{ my: 1 }} />
              </>
            )}
            <Collapse
              in={openConferenceEventManagemant}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {permissions["p_conference-category-list"] === true && (
                  <ListItemButton
                    sx={{ pl: 2 }}
                    onClick={() => history.push("/admin/conference/category")}
                  >
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <SwipeLeftIcon
                        onClick={() =>
                          history.push("/admin/conference/category")
                        }
                      />
                    </ListItemIcon>
                    <ListItemText primary="Conference Category" />
                  </ListItemButton>
                )}
                {permissions["p_conference-manage-conference-list"] ===
                  true && (
                  <ListItemButton
                    sx={{ pl: 2 }}
                    onClick={() => history.push("/admin/conference/manage")}
                  >
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <SwipeLeftIcon
                        onClick={() => history.push("/admin/conference/manage")}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Manage Conference" />
                  </ListItemButton>
                )}
                {permissions["p_conference-manage-session-list"] === true && (
                  <>
                    <ListItemButton
                      sx={{ pl: 2 }}
                      onClick={() =>
                        history.push("/admin/conference/list-session")
                      }
                    >
                      <ListItemIcon sx={{ color: "#1976d2" }}>
                        <SwipeLeftIcon
                          onClick={() =>
                            history.push("/admin/conference/list-session")
                          }
                        />
                      </ListItemIcon>
                      <ListItemText primary="Conference Session Category" />
                    </ListItemButton>
                    <Divider sx={{ my: 1 }} />
                  </>
                )}

                {permissions["p_conference-manage-session-list"] === true && (
                  <>
                    <ListItemButton
                      sx={{ pl: 2 }}
                      onClick={() =>
                        history.push("/admin/conference/sessions-list")
                      }
                    >
                      <ListItemIcon sx={{ color: "#1976d2" }}>
                        <SwipeLeftIcon
                          onClick={() =>
                            history.push("/admin/conference/sessions-list")
                          }
                        />
                      </ListItemIcon>
                      <ListItemText primary="Conference Session" />
                    </ListItemButton>
                    <Divider sx={{ my: 1 }} />
                  </>
                )}
              </List>
            </Collapse>

            {permissions["p_conference-participant-list"] === true && (
              <>
                <ListItemButton
                  onClick={handleClickConferenceParticpant}
                  sx={{ color: "#1976d2" }}
                >
                  <ListItemIcon sx={{ color: "#1976d2" }}>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="C-Participant"
                    sx={{ color: "#1976d2" }}
                  />
                  {openConferenceParticpant ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore sx={{ color: "#1976d2" }} />
                  )}
                </ListItemButton>
              </>
            )}
            <Collapse
              in={openConferenceParticpant}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {permissions["p_conference-participant-list"] === true && (
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() =>
                      history.push("/admin/conference/manage-particpant")
                    }
                  >
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <GroupAddIcon
                        onClick={() =>
                          history.push("/admin/conference/manage-particpant")
                        }
                      />
                    </ListItemIcon>
                    <ListItemText primary="Manage C-Participant" />
                  </ListItemButton>
                )}
                {permissions["p_conference-order-list"] === true && (
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() =>
                      history.push("/admin/conference/manage-particpant-order")
                    }
                  >
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <GroupAddIcon
                        onClick={() =>
                          history.push(
                            "/admin/conference/manage-particpant-order"
                          )
                        }
                      />
                    </ListItemIcon>
                    <ListItemText primary="C-Orders" />
                  </ListItemButton>
                )}

                 
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() =>
                      history.push("/admin/conference/manage-speaker")
                    }
                  >
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <GroupAddIcon
                        onClick={() =>
                          history.push(
                            "/admin/conference/manage-speaker"
                          )
                        }
                      />
                    </ListItemIcon>
                    <ListItemText primary="C-Speakers" />
                  </ListItemButton>
               

                {permissions["p_conference-memeber-statistics-list"] ===
                  true && (
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <GroupAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="C-Members Satistics" />
                  </ListItemButton>
                )}
                {permissions["p_conference-invitation-list"] === true && (
                  <>
                    <ListItemButton sx={{ pl: 4 }}>
                      <ListItemIcon sx={{ color: "#1976d2" }}>
                        <GroupAddIcon />
                      </ListItemIcon>
                      <ListItemText primary="C-Invitations" />
                    </ListItemButton>
                    <Divider sx={{ my: 1 }} />
                  </>
                )}
              </List>
            </Collapse>
            <Divider sx={{ my: 1 }} />
            {permissions["p_conference-coupons-list"] === true && (
              <>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() =>
                    history.push("/admin/conference/manage-coupon")
                  }
                >
                  <ListItemIcon sx={{ color: "#1976d2" }}>
                    <CommentIcon
                      onClick={() =>
                        history.push("/admin/conference/manage-coupon")
                      }
                    />
                  </ListItemIcon>
                  <ListItemText primary="C-Coupon" />
                </ListItemButton>
                <Divider sx={{ my: 1 }} />
              </>
            )}
            {permissions["p_conference-event-certificate-list"] === true && (
              <>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() =>
                    history.push(
                      `/admin/conference/conference-event-certificate`
                    )
                  }
                >
                  <ListItemIcon
                    sx={{
                      color: "#1976d2",
                    }}
                  >
                    <CommentIcon
                      onClick={() =>
                        history.push(
                          `/admin/conference/conference-event-certificate`
                        )
                      }
                    />
                  </ListItemIcon>
                  <ListItemText primary="C-Event Certificate" />
                </ListItemButton>
                <Divider sx={{ my: 1 }} />
              </>
            )}

            <Divider sx={{ my: 1 }} />
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon sx={{ color: "#1976d2" }}>
                <CommentIcon />
              </ListItemIcon>
              <ListItemText primary="C-Logs" />
            </ListItemButton>
            <Divider sx={{ my: 1 }} />
            {permissions["p_conference-report-list"] === true && (
              <>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => history.push("/admin/conference/reports")}
                >
                  <ListItemIcon sx={{ color: "#1976d2" }}>
                    <CommentIcon
                      onClick={() => history.push("/admin/conference/reports")}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Conference Report" />
                </ListItemButton>
                <Divider sx={{ my: 1 }} />
              </>
            )}
            {permissions["p_conference-user-manage-list"] === true && (
              <ListItemButton
                onClick={handleClickConferenceUser}
                sx={{ color: "#1976d2" }}
              >
                <ListItemIcon sx={{ color: "#1976d2" }}>
                  <ArticleIcon />
                </ListItemIcon>
                <ListItemText primary="Users" sx={{ color: "#1976d2" }} />
                {openClickConferenceUser ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore sx={{ color: "#1976d2" }} />
                )}
              </ListItemButton>
            )}
            <Collapse in={openClickConferenceUser} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {permissions["p_conference-user-manage-list"] === true && (
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() =>
                      history.push("/admin/conference/manage-user")
                    }
                  >
                    <ListItemIcon sx={{ color: "#1976d2" }}>
                      <GroupAddIcon
                        onClick={() =>
                          history.push("/admin/conference/manage-user")
                        }
                      />
                    </ListItemIcon>
                    <ListItemText primary="Manage User" />
                  </ListItemButton>
                )}
                <Divider sx={{ my: 1 }} />
              </List>
            </Collapse>

            {currentPath === "/admin/events" ? (
              ""
            ) : (
              <ListItemButton
                onClick={handleClickConferenceShopSetting}
                sx={{
                  color: "#1976d2",
                }}
              >
                <ListItemIcon
                  sx={{
                    color: "#1976d2",
                  }}
                >
                  <AppSettingsAltIcon />
                </ListItemIcon>
                {/*Sub in sub menue */}
                <ListItemText
                  primary="C-Setting"
                  sx={{
                    color: "#1976d2",
                  }}
                />
                {openConferenceSetting ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore
                    sx={{
                      color: "#1976d2",
                    }}
                  />
                )}
              </ListItemButton>
            )}
          </List>
        )}

        {currentPath === "/admin/events" ? (
          ""
        ) : (
          <Collapse in={openConferenceSetting} timeout="auto" unmountOnExit>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon
                sx={{
                  color: "#1976d2",
                }}
              >
                <ContactPageIcon
                  onClick={() =>
                    history.push("/admin/exhibition/exhibitor-profile")
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary="Profile"
                onClick={() =>
                  history.push("/admin/exhibition/exhibitor-profile")
                }
              />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon
                sx={{
                  color: "#1976d2",
                }}
              >
                <ContactPageIcon />
              </ListItemIcon>
              <ListItemText primary="BackUp" />
            </ListItemButton>
            {permissions["p_conference-bage"] == true ? (
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemIcon
                  sx={{
                    color: "#1976d2",
                  }}
                >
                  <ContactPageIcon
                    onClick={() => history.push("/admin/conference/badge")}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Conference Badge"
                  onClick={() => history.push("/admin/conference/badge")}
                />
              </ListItemButton>
            ) : (
              ""
            )}
            {permissions["p_event-email-template"] == true ? (
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemIcon
                  sx={{
                    color: "#1976d2",
                  }}
                >
                  <ContactPageIcon
                    onClick={() =>
                      history.push("/admin/conference/index-email")
                    }
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Email Template"
                  onClick={() => history.push("/admin/conference/index-email")}
                />
              </ListItemButton>
            ) : (
              ""
            )}
            {permissions["p_event-email-template"] == true ? (
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemIcon
                  sx={{
                    color: "#1976d2",
                  }}
                >
                  <ContactPageIcon
                    onClick={() => history.push("/admin/conference/currency")}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Currency Status"
                  onClick={() => history.push("/admin/conference/currency")}
                />
              </ListItemButton>
            ) : (
              ""
            )}
            {/* <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon sx={{
                color: '#1976d2'
              }}>
                <ContactPageIcon onClick={() => history.push('/admin/conference/evaluation-questions-admin')} />
              </ListItemIcon>
              <ListItemText primary="Evaluation" onClick={() => history.push('/admin/conference/evaluation-questions-admin')} />
            </ListItemButton> */}

            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon
                sx={{
                  color: "#1976d2",
                }}
              >
                <ContactPageIcon
                  onClick={() =>
                    history.push("/admin/conference/evaluation-list")
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary="Evaluation Report"
                onClick={() =>
                  history.push("/admin/conference/evaluation-list")
                }
              />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon
                sx={{
                  color: "#1976d2",
                }}
              >
                <ContactPageIcon
                  onClick={() =>
                    history.push("/admin/conference/terms-and-conditions")
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary="Terms And Conditions"
                onClick={() =>
                  history.push("/admin/conference/terms-and-conditions")
                }
              />
            </ListItemButton>



               <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon
                sx={{
                  color: "#1976d2",
                }}
              >
                <ContactPageIcon
                  onClick={() =>
                    history.push("/admin/conference/whatsapp-custom-message")
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary="Whatsapp Custom Message"
                onClick={() =>
                  history.push("/admin/conference/whatsapp-custom-message")
                }
              />
            </ListItemButton>


          </Collapse>
        )}
      </Collapse>
    </div>
  );
};

export default PmsNav;
